module.exports = __webpack_public_path__ + "static/okeowo-31bbb434fe99eee60bcf0a4f197ad1e7.jpg";